__webpack_public_path__=(window['__webpack_public_path__'] + '////assets/plugin-web-custom-payment/').replace(/[/]{3,}/g, "/");